import { defineMessage } from 'services/localization';

export const messages = {
    invitedUserTitle: defineMessage('name_has_not_yet_accept_on_to_this_organisation'),
    notInvitedUserTitle: defineMessage('name_has_not_yet_been_invited_to_this_organisation'),
    rejectedUserTitle: defineMessage('name_rejected_the_invitation_to_this_organisation'),
};
